'use client';

import type { ReactNode } from 'react';
import { FindingsRenderer, parseFindingData } from './FindingsRenderer';
import { FindingDescriptionHITLRenderer } from '../../HITL/renderers/FindingDescriptionHITLRenderer';
import type { HITLContentContext } from '../../tool-config-types';
import type { FindingDescriptionData } from '../../HITL/types';
import type { Finding } from './types';

export const renderFindingContent = (ctx: HITLContentContext): ReactNode => {
  // Convert extractedData to Finding[] format
  const findings: Finding[] = ctx.extractedData
    .map((item) => parseFindingData(item as Partial<Finding>))
    .filter((item): item is Finding => item !== null);

  if (findings.length === 0) return null;

  return (
    <FindingsRenderer
      findings={findings}
      maxHeight={ctx.maxHeight}
      variant="detailed"
    />
  );
};

export const renderFindingDescriptionContent = (
  ctx: HITLContentContext,
): ReactNode => {
  if (ctx.extractedData.length === 0) return null;
  return (
    <FindingDescriptionHITLRenderer
      findings={ctx.extractedData as FindingDescriptionData[]}
      maxHeight={ctx.maxHeight}
      variant="detailed"
    />
  );
};
